/**
 * Loads the Ask My Website AI concierge widget on the dashboard itself - the real
 * product bot that answers questions about the app for logged-in users (Radu a pus-o
 * deliberat pentru clienții care folosesc aplicația). Keys-from-env, per mediu:
 * backendul servește `/app-keys.js` (window.AIG_APP_BOT), iar loader-ul îl transformă
 * într-un singur `<script>`.
 *
 * Înlocuiește vechiul snippet hardcodat din index.html (app-id de prod, sdk.js de prod)
 * - care pe staging vorbea cu botul de producție. Dashboard-ul E chiar app.<mediu>,
 * deci SDK-ul se încarcă de pe `location.origin`; app-id-ul vine din APP_BOT_APP_ID.
 *
 * NU e demo: fără `data-demo`, deci merge pe calea publică normală (/v1/apps/.../ask),
 * nu pe /v1/demo/ask. Guarded - nu injectează de două ori, un config lipsă nu aruncă.
 */
declare global {
  interface Window {
    AIG_APP_BOT?: { appId?: string; publicKey?: string };
  }
}

const MARKER_ATTR = "data-dashboard-ai-concierge";

export function initAIConciergeLoader(): void {
  try {
    if (document.querySelector(`script[${MARKER_ATTR}]`)) return;

    const keys = window.AIG_APP_BOT;
    if (!keys?.appId || !keys?.publicKey) return;

    const script = document.createElement("script");
    // Dashboard-ul e servit chiar de pe originea API (app.<mediu>), deci SDK-ul vine
    // de pe location.origin - pe staging app.staging, pe prod app.askmywebsiteai.com,
    // local backendul de la /sdk.js. Fără hardcodare de prod.
    script.src = `${location.origin}/sdk.js`;
    script.dataset.appId = keys.appId;
    script.dataset.publicKey = keys.publicKey;
    script.setAttribute(MARKER_ATTR, "true");
    script.addEventListener("error", () => {
      // Fail silently - a missing/broken widget script must never break the dashboard.
    });
    document.body.appendChild(script);
  } catch {
    // Never let widget loading break the dashboard.
  }
}
